<template>
  <form @submit.prevent="submit" class="mx-auto">
    <div class="lg:flex">
      <div class="mb-2 lg:w-1/2 lg:px-1">
        <div class="flex flex-col px-2 py-1 text-left bg-white rounded border border-gray-300">
          <label for="name" class="text-sm text-gray-500">Company Name</label>
          <input v-model="fields.company" id="name" type="text" class="text-gray-600 focus:outline-none" />
        </div>
        <div v-if="errors && errors.company" class="text-sm font-medium text-red-600">{{ errors.company[0] }}</div>
      </div>
      <div class="mb-2 lg:w-1/2 lg:px-1">
        <div class="flex flex-col px-2 py-1 text-left bg-white rounded border border-gray-300">
          <label for="name" class="text-sm text-gray-500">Name</label>
          <input v-model="fields.name" id="name" type="text" class="text-gray-600 focus:outline-none" />
        </div>
        <div v-if="errors && errors.name" class="text-sm font-medium text-red-600">{{ errors.name[0] }}</div>
      </div>
    </div>
    <div class="lg:flex">
      <div class="mb-2 lg:w-1/2 lg:px-1">
        <div class="flex flex-col px-2 py-1 text-left bg-white rounded border border-gray-300">
          <label for="contact_number" class="text-sm text-gray-500">Contact Number</label>
          <input v-model="fields.contact" id="contact_number" type="tel" class="text-gray-600 focus:outline-none" />
        </div>
        <div v-if="errors && errors.contact" class="text-sm font-medium text-red-600">{{ errors.contact[0] }}</div>
      </div>
      <div class="mb-2 lg:w-1/2 lg:px-1">
        <div class="flex flex-col px-2 py-1 text-left bg-white rounded border border-gray-300">
          <label for="email" class="text-sm text-gray-500">Email</label>
          <input v-model="fields.email" id="email" type="email" class="text-gray-600 focus:outline-none" />
        </div>
        <div v-if="errors && errors.email" class="text-sm font-medium text-red-600">{{ errors.email[0] }}</div>
      </div>
    </div>
    <div class="lg:px-1">
      <div class="flex flex-col px-2 py-1 text-left bg-white rounded border border-gray-300">
        <label for="message" class="text-sm text-gray-500">Message</label>
        <textarea
          v-model="fields.message"
          id="message"
          rows="4"
          type="text"
          class="p-0 px-0 m-0 h-auto font-sans text-base text-gray-600 border-0 focus:outline-none"></textarea>
      </div>
      <div v-if="errors && errors.message" class="text-sm font-medium text-red-600">{{ errors.message[0] }}</div>
    </div>
    <div class="mt-2">
      <div class="flex justify-center">
        <div recaptcha-el class="mx-auto"></div>
      </div>
      <div class="text-sm text-red-600">{{ recaptchaError }}</div>
    </div>

    <div class="pt-6">
      <button
        v-text="busy ? 'Submitting...' : 'GET STARTED NOW'"
        type="submit"
        class="py-2 mx-auto w-2/3 text-lg font-medium text-white rounded border-none opacity-90 transition md:w-56 bg-activa-blue-default hover:opacity-100 disabled:cursor-wait disabled:opacity-50"></button>
    </div>
  </form>
</template>

<script>
import hapiMixins from 'hapiform-with-recaptcha'

export default {
  mixins: [hapiMixins],
  data() {
    return {
      hapiformID: "d151fc79-4341-4198-a064-595bcf8ad934",
      redirectTo: "/thank-you",
    };
  },

};
</script>
